import React, { useState, useEffect, useContext } from "react";
import "./SectionToolbar.scss";
import { useSelector } from "react-redux";

import { Tab, Tabs } from "react-bootstrap";
import DatePicker from "../../Components/DatePicker/datePicker";
import SwitchButton from "../Buttons/SwitchButton/SwitchButton";
import { ResumePopupContext } from "../../Context/resumePopupContext";
import DateEdit from "../DatePickerNew/DatePicker";
import ReactTooltip from "react-tooltip";
import OutsideClickHandler from "react-outside-click-handler";
import { achievementsSvg } from "../../masterData";
import { skillSliderTypes, languageSliderTypes } from "../../TemplateConfig";

function SectionToolbar(props) {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const { setSideBasic, setSuggestionSection, setJobTile, setSuggestionIndex } =
    useContext(ResumePopupContext);
  const handleDatePicker = () => {
    setShowDatePicker(true);
  };
  const editorSettings = useSelector(
    (state) => state.editorData.editorSettings
  );
  useEffect(() => {
    if (props && props.showDatePicker) {
      setShowDatePicker(true);
    }
  }, [props && props.showDatePicker]);

  const boldClick = (props) => {
    props.quill();
  };

  const handleSettings = (e) => {
    setShowSettings(!showSettings);
  };
  const handleCalander = (e) => {
    setShowDatePicker(!showDatePicker);
  };
  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const editIconClick = () => {
    if (props.sectionId == "experience") {
      setJobTile(
        props &&
          props.response &&
          props.response.position &&
          props.response.position
          ? props.response.position
          : ""
      );
    }

    setSideBasic(true);
    setSuggestionSection(props.sectionId);
    setSuggestionIndex(props.index);
  };
  useEffect(() => {
    if (props.newSectionFocus != props.sectionId) {
      setShowDatePicker(false);
    }
  }, [props.newSectionFocus]);

  const handleSliderType = (type) => {
    props.handleSliderChange(type);
  };

  const handleLanguageSlideChange = (type) => {
    props.handleLanguageSliderChange(type);
  };
  return (
    <>
      <ReactTooltip />
      <div className="row global_toolbar_main item_toolbar">
        <div className="global_toolbar_container">
          <div className="d-flex global_toolbar_inner">
            <div className="justify-content-between section_tools">
              {props && props.sectionId.includes("custom") ? (
                ""
              ) : (
                <a
                  className="section-handler"
                  onClick={(e) => {
                    props.addAdditionalField(
                      props.sectionRef,
                      props && props.row,
                      props.sectionId
                    );
                    e.stopPropagation();
                  }}
                >
                  <span data-tip="Add section">
                    <i className="fa fa-plus" aria-hidden="true"></i>
                  </span>
                </a>
              )}
              {/* <a className="section-handler">
              <span onClick={() => editIconClick()}>
                <i className="fa fa-pencil" aria-hidden="true"></i>
              </span>
            </a> */}
              {props && props.indexString && props.indexString != "0" && (
                <>
                  <a className="section-handler">
                    <span
                      data-tip="Move up"
                      onClick={(e) =>
                        props.sectionItemMoveUp(e, props.index, props.sectionId)
                      }
                    >
                      <i className="fa fa-arrow-up" aria-hidden="true"></i>
                    </span>
                  </a>
                </>
              )}

              {props.row.length != props.index + 1 && (
                <>
                  <a className="section-handler">
                    <span
                      data-tip="Move down"
                      onClick={(e) =>
                        props.sectionItemMoveDown(
                          e,
                          props.index,
                          props.sectionId
                        )
                      }
                    >
                      <i className="fa fa-arrow-down" aria-hidden="true"></i>
                    </span>
                  </a>
                </>
              )}

              <a className="section-handler">
                <span
                  data-tip="Delete"
                  onClick={() =>
                    props.handleDelete(props.index, props.sectionId)
                  }
                >
                  <i className="fa fa-trash" aria-hidden="true"></i>
                </span>
              </a>
            </div>

            <div className="justify-content-between description_tools">
              {/* <span className="vl"></span> */}
              {(props && props.sectionId == "education") ||
              (props && props.sectionId == "experience") ||
              (props && props.sectionId.includes("customDate")) ? (
                <a>
                  <span
                    className="date-picker-icon"
                    data-tip="Calander"
                    onClick={handleCalander}
                  >
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                  </span>
                </a>
              ) : (
                ""
              )}
              {props && props.sectionId == "interests" ? (
                <a>
                  <span
                    data-tip="Settings"
                    className="section-item-settings"
                    onClick={handleSettings}
                  >
                    <i className="fa fa-cog" aria-hidden="true"></i>
                  </span>
                </a>
              ) : (
                <a>
                  <span
                    data-tip="Settings"
                    className="section-item-settings"
                    onClick={handleSettings}
                  >
                    <i className="fa fa-cog" aria-hidden="true"></i>
                  </span>
                </a>
              )}

              {showSettings && showSettings && (
                <OutsideClickHandler
                  onOutsideClick={(e, value) => {
                    const parentWithClass = e.target.closest(
                      ".profile_settings_div"
                    );
                    const anotherParentWithClass = e.target.closest(
                      ".section-item-settings"
                    );
                    if (
                      showSettings &&
                      showSettings &&
                      parentWithClass == null &&
                      anotherParentWithClass == null
                    ) {
                      handleSettings();
                    }
                  }}
                >
                  <div className="profile_settings_div">
                    {props &&
                      props.response &&
                      props.response.showFields &&
                      Object.keys(
                        props &&
                          props.response &&
                          props.response.showFields &&
                          props.response.showFields
                      ).map((res, index) => {
                        if (res == "website") {
                          return;
                        }
                        if (props.sectionId == "skills") {
                          if (res == "name" || res == "description") {
                            return;
                          }
                        }
                        if (props.sectionId == "achievements") {
                          // if (res == "name" || res == "icon") {
                          //   return;
                          // }
                        }
                        if (props.sectionId == "languages") {
                          if (
                            res == "name" ||
                            res == "description" ||
                            res == "proficiencyText"
                          ) {
                            return;
                          }
                        }
                        if (props.sectionId == "interests") {
                          if (
                            res == "name" ||
                            res == "description" ||
                            res == "level"
                          ) {
                            return;
                          }
                        }
                        if (res == "position") {
                          return (
                            <>
                              <div
                                className="d-flex justify-content-between p-2"
                                onClick={() =>
                                  props.changeSettings(res, props.index)
                                }
                              >
                                <p className="m-0 ">Show Role Title:</p>
                                <SwitchButton
                                  checked={
                                    props &&
                                    props.response &&
                                    props.response.showFields &&
                                    props.response.showFields[res]
                                  }
                                />
                              </div>
                            </>
                          );
                        }
                        return (
                          <>
                            <div
                              className="d-flex justify-content-between p-2"
                              onClick={() =>
                                props.changeSettings(res, props.index)
                              }
                            >
                              <p className="m-0 ">Show {capitalize(res)}:</p>
                              <SwitchButton
                                checked={
                                  props &&
                                  props.response &&
                                  props.response.showFields &&
                                  props.response.showFields[res]
                                }
                              />
                            </div>
                          </>
                        );
                      })}

                    {props?.sectionId == "skills" && (
                      <div className="w-100">
                        <div className="d-flex  p-2">
                          <p className="m-0 mt-2">Slider Style:</p>
                          <div>
                            {skillSliderTypes?.map((res, index) => (
                              <div
                                className={`skill-slider-type mt-2 ${
                                  editorSettings?.skills?.sliderType === res
                                    ? "green-slider"
                                    : ""
                                }`}
                                onClick={() => handleSliderType(res)}
                              ></div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                    {props?.sectionId == "languages" && (
                      <div className="w-100">
                        <div className="d-flex  p-2">
                          <p className="m-0 mt-2">Language Percentage:</p>
                          <div>
                            <input
                              type="range"
                              className="form-contol"
                              min={1}
                              max={100}
                              step={1}
                              onChange={(e) =>
                                props.languageHandler(
                                  "level",
                                  props.index,
                                  e.target.value,
                                  props.sectionId
                                )
                              }
                              value={props?.response?.level}
                              onBlur={() => props.resumeUpdate()}
                            />
                          </div>
                        </div>
                        <div className="d-flex  p-2">
                          <p className="m-0 mt-2">Slider Style:</p>
                          <div>
                            {languageSliderTypes?.map((res, index) => (
                              <div
                                className={`skill-slider-type mt-2 ${
                                  editorSettings?.languages?.indicatorType ===
                                  res
                                    ? "green-slider"
                                    : ""
                                }`}
                                onClick={() => handleLanguageSlideChange(res)}
                              ></div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                    {props?.sectionId == "achievements" && (
                      <div className="w-100">
                        <div className="  p-2">
                          <p className="m-0 mt-2">Achievement Svg:</p>
                          <div className="d-flex ">
                            {
                              // !props.response.showFields["isSvg"] &&
                              achievementsSvg &&
                                achievementsSvg.map((SvgComponent, index) => (
                                  <>
                                    <div
                                      className="mr-2"
                                      onClick={() =>
                                        props.handleAchievementSvg(
                                          props.index,
                                          index
                                        )
                                      }
                                    >
                                      <SvgComponent
                                        key={index}
                                        color={"black"}
                                      />
                                    </div>
                                  </>
                                ))
                            }
                          </div>
                        </div>
                      </div>
                    )}
                    {props?.sectionId == "additionalSkills" && (
                      <div className="w-100">
                        <div className="d-flex  p-2">
                          <p className="m-0 mt-2">Border Style:</p>
                          <div>
                            {[true, false]?.map((res, index) => (
                              <div
                                className={`skill-slider-type mt-2 ${
                                  editorSettings?.additionalSkills?.border ==
                                  res
                                    ? "green-slider"
                                    : ""
                                }`}
                                onClick={() => handleSliderType(res)}
                              ></div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </OutsideClickHandler>
              )}

              {showDatePicker && showDatePicker && (
                <>
                  <DateEdit
                    dateHandler={props.dateHandler}
                    index={props.index}
                    response={props.response}
                    showDatePicker={showDatePicker}
                    setShowDatePicker={setShowDatePicker}
                    isSelectedFrom={props.isSelectedFrom}
                    sectionId={props.sectionId}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SectionToolbar;
